import {
    FETCH_ACTIVITYLIST_REQUEST,
    FETCH_ACTIVITYLIST_SUCCESS,
    FETCH_ACTIVITYLIST_FAILURE,
  } from "./ActivityListTypes";
  
  const initialState = {
    loading: false,
    activityList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ACTIVITYLIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_ACTIVITYLIST_SUCCESS:
        return {
          loading: false,
          activityList: action.payload,
          error: "",
        };
      case FETCH_ACTIVITYLIST_FAILURE:
        return {
          loading: false,
          activityList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  